import { CLASS_BOOST_SD_BIS_PHONE_INPUT_ERROR, PHONE_ERROR_MESSAGE } from '../constants';

export function handlePhoneValidation(phoneInput, errorMessageElement, returnOnly = false) {
  const phonePattern = /^\+?[0-9]{6,18}$/;
  const isValid = phonePattern.test(phoneInput.value.trim());

  if (errorMessageElement) {
    if (!isValid) {
      errorMessageElement.textContent = PHONE_ERROR_MESSAGE;
      errorMessageElement.style.display = 'block';
      phoneInput.classList.add(CLASS_BOOST_SD_BIS_PHONE_INPUT_ERROR);
    } else {
      errorMessageElement.style.display = 'none';
      phoneInput.classList.remove(CLASS_BOOST_SD_BIS_PHONE_INPUT_ERROR);
    }
  } else {
    console.error('Phone error message element not found.');
  }

  return returnOnly ? isValid : null;
}
